export default function () {
  return new Date().getMonth() + 1;
}



// WEBPACK FOOTER //
// ./src/modules/todaysMonthNumber.js